
const swiper = new Swiper('.swiper-custom', {
  loop: false,
  centeredSlides:false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar-custom',
  //   draggable: true,
  //   observeParents: true,
  // },
});
